import React, { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";

const PrivateRoute = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return localStorage.getItem("accessToken") ? (
    <main className="h-full w-full p-2">
      <Navbar onMobileMenuToggle={() => setIsMobileOpen(true)} />
      <div className="flex flex-1 md:gap-2 py-2 h-[calc(100vh-5rem)]">
        <div className="max-w-[14vw] items-center">
          <Sidebar
            isMobileOpen={isMobileOpen}
            setIsMobileOpen={setIsMobileOpen}
          />
        </div>
        <div className="w-full h-full">
          <Outlet />
        </div>
      </div>
    </main>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;
